// Lightweight compatibility shim — the legacy 14-service data file has been
// replaced by the SEO content system in src/lib/seo-content.ts. This file
// exposes a minimal `services` array (slug + title) so dropdowns in
// BookAppointment, Contact and AdminReviews keep working without a full
// migration to the SEO page registry.
import { SEO_PAGES } from "./seo-content";
import { CATEGORIES } from "./seo-categories";

const HUB_SLUGS = new Set(CATEGORIES.map((c) => c.hubSlug));

export interface ServiceListItem {
  slug: string;
  title: string;
}

const titleFromPage = (h1: string) =>
  h1.split(" — ")[0].split(" in Kalyan")[0].trim();

export const services: ServiceListItem[] = SEO_PAGES
  .filter((p) => !HUB_SLUGS.has(p.slug)) // exclude category hub pages from dropdowns
  .map((p) => ({ slug: p.slug, title: titleFromPage(p.h1) }));